import { render, staticRenderFns } from "./SweetAlertHeader.vue?vue&type=template&id=136ef8fe&scoped=true&"
import script from "./SweetAlertHeader.vue?vue&type=script&lang=js&"
export * from "./SweetAlertHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136ef8fe",
  null
  
)

export default component.exports